var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserDeleteCross = function SvgUserDeleteCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 5.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5M7.5 12.5h-7v-.542A4.51 4.51 0 0 1 5.204 7.5a4.5 4.5 0 0 1 1.86.5M13.5 9.26 9.26 13.5M9.26 9.26l4.24 4.24"
  }))));
};
export default SvgUserDeleteCross;